"use client";

import Footer from "@/components/shared/footer";
import Navbar from "@/components/shared/navbar/navbar";
import OpenDay from "@/components/openday/openday";
import PageVisibilityGuard from "@/components/shared/page-visibility-guard";

export default function OpendayPage() {
	return (
		<PageVisibilityGuard pageKey="openday">
			<main className="min-h-screen bg-[var(--background)]">
				<Navbar />
				<OpenDay />
				<Footer />
			</main>
		</PageVisibilityGuard>
	);
}
